import type { INovaDock } from '@/interfaces/nova';
import { resolveDockLoadTypes } from '@/services/dockLoadTypes';

type WarehouseWithHeadquarters = { externalHeadquartersId?: string | number | null };

export function getHeadquartersId(warehousesKeyedByExternalId: {
  [key: string]: WarehouseWithHeadquarters | undefined;
}) {
  return Object.values(warehousesKeyedByExternalId).find(
    warehouse => warehouse?.externalHeadquartersId
  )?.externalHeadquartersId;
}

export function parseDockJsonColumns(
  dock: Pick<INovaDock, 'schedule' | 'externalLoadTypeIds'>,
  loadTypeIdsKeyedByExternalId: { [key: string]: string }
) {
  const originalSchedule = dock.schedule;
  try {
    const schedule = JSON.parse(originalSchedule as string);
    const resolved = resolveDockLoadTypes(
      JSON.parse(dock.externalLoadTypeIds),
      loadTypeIdsKeyedByExternalId
    );
    return { schedule, originalSchedule, ...resolved };
  } catch (error) {
    const reason = error instanceof Error ? error.message : 'unknown error';
    return {
      schedule: originalSchedule,
      originalSchedule,
      loadTypeIds: [] as string[],
      failureMessage: `Dock schedule or load types are not valid JSON: ${reason}`
    };
  }
}
